<template lang="pug">
    v-dialog(v-model="dialog" v-if="dialog" fullscreen hide-overlay transition="dialog-bottom-transition")
        template
            v-snackbar(
                v-model="snackbar"
                :timeout="10000"
                color='error'
            ) {{ snackbarMessage }}    
            v-toolbar(dark dense color="red" class="navFixed")
                v-toolbar-title i-Permit Preview    
                v-spacer
                v-toolbar-title(v-if="ip.ipPengesahan && ip.ipStatus !== 10 && getApproveStatus(ip.ipPengesahan.ipWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipPengesahan.ipWorkflow))}}
                v-toolbar-title(v-else-if="getApproveStatus(ip.ipWorkflow) == '8'") Rejected on {{formatDate(getApproveDate(ip.ipWorkflow))}}
                v-toolbar-items
                    v-btn(v-if="dialogType !== 'creator' && isCurrentApprover()" @click.stop="approvalDialog = true" color="red" depressed title='Approval' class="blink") 
                        v-icon(title="Approval") assignment_turned_in
                        | &nbsp; Approval
                    v-dialog(v-if="dialogType !== 'creator' && isCurrentApprover()" v-model="approvalDialog" persistent max-width="500px")
                        v-card()
                            v-card-title(class="headline grey lighten-2") Approval Form
                            v-card-text
                                v-layout(wrap)
                                    v-flex(xs12)
                                        v-radio-group(v-model="approval" row)
                                            v-radio(label="Approve" color="success" value="7")
                                            v-radio(v-if="ip.ipStatus !== 10" label="Reject" color="red" value="8")
                                            v-radio(v-if="ip.ipStatus == 10" label="Need Review" color="yellow darken-4" value="11")
                                            v-radio(v-else label="Need Review" color="yellow darken-4" value="3")
                                    v-flex(xs12)
                                        v-textarea(
                                            v-model="comment"
                                            filled
                                            label="Comment (Optional)"
                                            value=""
                                        )
                            v-card-actions
                                v-spacer
                                v-btn(text @click.native="approvalDialog = false") Close
                                v-btn(:disabled="!approval" text :loading="approvalDialog2" color="blue darken-1" @click="approvalDialog2 = true") Submit
                                v-dialog(
                                    v-model="approvalDialog2"
                                    hide-overlay
                                    persistent
                                    width="300")
                                    v-card(color="primary" dark)
                                    v-card-text Processing. Please wait!
                                        v-progress-linear(indeterminate color="white" class="mb-0")
                    v-btn(v-if="this.ip.ipStatus == 4 || this.ip.ipStatus == 8" @click="shareIP();" color="red" depressed title="Share" )
                        v-icon share
                        | &nbsp; Share
                        v-dialog(v-model="share" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Share
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        ShareNetwork(
                                            v-for="network in networks"
                                            :key="network.key"
                                            class="ma-3 pa-3 green"
                                            :network="network.network"
                                            style="border-radius: 10px; box-shadow: -2px 4px #888888;"
                                            :url="shortenUrl"
                                            :title="sharing.title"
                                            :description="sharing.description"
                                        ) 
                                            i(:class="network.icon" style="color:white")
                                            span(class="ma-3" style="color:white") {{ network.name }}
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="share = false") Close
                    v-btn(@click="ip.ipStatus == 4 || ip.ipStatus == 8 ? print = true : printIP(ip._id)" color="red" depressed title="Print" )
                        v-icon print
                        | &nbsp; Print
                        v-dialog(v-model="print" persistent max-width="400px")
                            v-card
                                v-card-title(class="headline grey lighten-3") Print Document
                                v-alert(:value='true' color="success")
                                    h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
                                v-flex(class="headline grey lighten-3")
                                    v-row(no-gutters align="center" justify="center")
                                        v-btn(@click="printIP(ip._id); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-print" style="color:white")
                                            span(class="ma-3" style="color:white") Print
                                        v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                            i(class="far fah fa-lg fa fa-share-alt" style="color:white")
                                            span(class="ma-3" style="color:white") Share
                                v-spacer
                                v-flex(class="text-end headline grey lighten-2")
                                    v-btn(color="blue darken-1" text @click.native="print = false") Close
                    v-btn(@click.native="dialog = false" color="red" depressed)
                        v-icon(title="Close") cancel
                        | &nbsp; Close
            div(:id="ip._id")
                v-list(class="print-bg padTop60")
                    div()
                        .page(size="Auto")
                            div(class="view-width" style="font-size:10px;")
                                div(v-if="ip.ipStatus == 4" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Approve.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 8" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/reject.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 13" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Auto Canceled.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 14" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Auto Rejected.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 15" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Auto Dropped.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                div(v-else-if="ip.ipStatus == 12" id="background")
                                    p(class="fontWatermarkUp" ) {{ip.ipNo}}
                                    img(src="../assets/Done.png" class="imgWatermark")
                                    p(class="fontWatermarkDown" ) {{ip.ipNo}}
                                table(class="view-width tableInput" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td( class="align-center" width="150" rowspan="3")
                                                img(class="verMiddle" src="../assets/BORNEO-INDOBARA.jpg" width="120px")
                                            td(class="align-center") SINARMAS MINING SYSTEM
                                            td( class="align-center" width="150" rowspan="3") 
                                                img(class="verMiddle" :src="`${API_URL}/qr/generate/?ipNo=${ip.ipNo}&formCode=${ip.ipForm}`" style="width:80px;margin:2px 0;")
                                        tr
                                            td(class="align-center") FORMULIR
                                        tr
                                            td(class="align-center") {{ formName[ip.ipForm] }}
                                
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class="headerTable" colspan="6") I. INFORMASI UMUM
                                        tr
                                            td(width="150" class="headerTable") Judul Pekerjaan
                                            td(colspan="3") {{ ip.ipJudulPekerjaan }}
                                        tr
                                            td(width="150" class="headerTable" style="font-weight: bold;" ) Jenis Pengawalan
                                            td(colspan="3" style="font-weight: bold;") {{ setJenisPengawalan }}
                                        tr
                                            td(width="150" class="headerTable" ) Tanggal Perizinan
                                            td(colspan="3") {{ formatDate(ip.ipTanggalPerizinanStart) }} s/d {{ formatDate(ip.ipTanggalPerizinanEnd) }}
                                        tr
                                            td(width="150" class="headerTable" ) Waktu
                                            td(colspan="3") {{ ip.ipStartPengawalan }}
                                        tr
                                            td(width="150" class="headerTable" ) Nomor Izin Kerja
                                            td(colspan="3") {{ ip.ipNo }}
                                        tr
                                            td(width="150" class="headerTable" ) Nama Pengawas Pengawalan
                                            td(colspan="3") {{ ip.ipPemegangIzin.name }}
                                        tr
                                            td(width="150" class="headerTable" ) Kategori
                                            td(colspan="3") Kategori {{ ip.ipSelectedCategory }}
                                        tr
                                            td(width="150" class="headerTable") Perusahaan
                                            td(colspan="3") {{ ip.ipPerusahaan }}
                                        tr
                                            td(class="headerTable") Departemen
                                            td {{ ip.ipDeptDivisi }}
                                            td(width="150" class="headerTable") Divisi
                                            td {{ ip.ipDivisi }}
                                        tr
                                            td(width="150" class="headerTable") Jumlah iring-iringan unit
                                            td(colspan="3") {{ ip.ipJumlahUnit }}
                                        tr
                                            td(class="headerTable") Rute Pengawalan Dari
                                            td {{ ip.ipLokasiAwal }}
                                            td(width="150" class="headerTable") Rute Pengawalan Sampai
                                            td {{ ip.ipLokasiTujuan }}
                                        tr
                                            td(class="headerTable") Sublokasi
                                            td {{ ip.ipSublokasiAwal }}
                                            td(width="150" class="headerTable") Sublokasi
                                            td {{ ip.ipSublokasiTujuan }}
                                        tr
                                            td(class="headerTable") Lamanya Dari Jam
                                            td {{ ip.ipStartPengawalan }}
                                            td(width="100" class="headerTable") Sampai Jam
                                            td {{ ip.ipEndPengawalan }}
                                        tr
                                            td(class="headerTable") Lebar Keseluruhan Unit
                                            td {{ ip.ipLebarUnit }} M
                                            td(width="100" class="headerTable") Tinggi Keseluruhan Unit
                                            td {{ ip.ipTinggiUnit }} M
                                        tr
                                            td(class="headerTable") Panjang Keseluruhan Unit
                                            td {{ ip.ipPanjangUnit }} M
                                            td(width="100" class="headerTable") Berat Keseluruhan Unit
                                            td {{ ip.ipBeratUnit }} Ton
                                
                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class="headerTable") II. DESKRIPSI DETAIL PENGAWALAN
                                        tr
                                            td
                                                div(v-html="ip.ipDetailPengawalan" class="ck-content")
                                
                                table(style="margin-top:10px;width:3cm;border: 1px solid black;" class="autoPageBreak")
                                    tbody(v-if="ip.ipAttachmentFiles.docPendukung") 
                                        v-btn(tile text @click="download(ip.ipAttachmentFiles.docPendukung)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal" height="auto") 
                                            tr
                                                td(style="padding-left:1px" ) 
                                                    v-icon(small) mdi-attachment
                                                td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                                td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                                    img(src="../assets/check.png" width="10" )
                                    tbody(v-else)
                                        tr
                                            td(style="padding-left:1px" ) 
                                                v-icon(small) mdi-attachment
                                            td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                            td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                                img(src="../assets/close.png" width="10" class="verMiddle")
                                
                                table(class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class="headerTable pl-2" colspan="6") III. PENGESAHAN
                                        tr
                                            td(class="pl-2" colspan="6") 
                                                b Catatan:
                                                ul
                                                li 
                                                    i Pengajuan internal BIB ditandatangani oleh pengawas area kerja & Dept. Head Custodian, kemudian divalidasi oleh OHS Operation masing-masing area.
                                                li 
                                                    i Jika pengajuan izin dari mitra kerja maka harus ditandatangani oleh PJO dan penanggung jawab area, serta divalidasi dahulu oleh praktisi safety.
                                        tr
                                            td(class="headerTable pl-2" rowspan="2" width="5%") Diajukan Oleh
                                            td(class="headerTable align-center" width="20%") Nama
                                            td(class="headerTable align-center" width="20%") Jabatan
                                            td(class="headerTable align-center" width="20%") Tanggal
                                            td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                        tr
                                            td
                                                div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                                    br
                                                    | {{ ip.ipWorkflow[0].name }}
                                                    br
                                                div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                                    br
                                                    | {{ ip.ipWorkflow[0].admin_reject == true ? ip.ipWorkflow[0].admin_detail.name : ip.ipWorkflow[0].name }}
                                                    br
                                                div(v-else class="emptySign")
                                            td
                                                div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                                    br
                                                    | {{ ip.ipWorkflow[0].title }}
                                                    br
                                                div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                                    br
                                                    | {{ ip.ipWorkflow[0].admin_reject == true ? 'Admin' : ip.ipWorkflow[0].title }}
                                                    br
                                                div(v-else class="emptySign") {{ jabatanDetail(ip.ipWorkflow[0].postAs, 0, ip.ipForm) }}
                                            td
                                                div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                                    br
                                                    | {{approvalTime(ip.ipWorkflow[0].date)}}
                                                    br
                                                div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                                    br
                                                    | {{approvalTime(ip.ipWorkflow[0].date)}}
                                                    br
                                                div(v-else class="emptySign")
                                            td
                                                div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                                    img(src="../assets/close-64.png" style="width:25px;")
                                                div(v-else class="emptySign")
                                            td
                                                p(v-if="ip.ipWorkflow[0].comment || ''" class="align-left top-align comment") {{ ip.ipWorkflow[0].comment }}
                                                div(v-else class="emptySign") 
                                        tr
                                            td(class="headerTable pl-2" :rowspan="ip.ipWorkflow.length + 1" width="5%") Disetujui oleh
                                            td(class="headerTable align-center" width="20%") Nama
                                            td(class="headerTable align-center" width="20%") Jabatan
                                            td(class="headerTable align-center" width="20%") Tanggal
                                            td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                        tr(v-for="(workflow, index) in ip.ipWorkflow.slice(1)")
                                            td
                                                div(v-if="workflow.status == 7" class="approved")
                                                    br
                                                    | {{ getNameApproverKTT(workflow) }}
                                                    br
                                                div(v-else-if="workflow.status == 8" class="approved")
                                                    br
                                                    | {{ workflow.admin_reject == true ? workflow.admin_detail.name : getNameApproverKTT(workflow) }}
                                                    br
                                                div(v-else class="emptySign")
                                            td
                                                div(v-if="workflow.status == 7" class="approved")
                                                    br
                                                    | {{ getTitleApprover(workflow) }}
                                                    br
                                                div(v-else-if="workflow.status == 8" class="approved")
                                                    br
                                                    | {{ workflow.admin_reject == true ? 'Admin' : getTitleApprover(workflow) }}
                                                    br
                                                div(v-else class="emptySign")  {{ (workflow.title == undefined) ? jabatanDetail(workflow.postAs, index, ip.ipForm) : '' }}
                                            td
                                                div(v-if="workflow.status == 7" class="approved")
                                                    br
                                                    | {{approvalTime(workflow.date)}}
                                                    br
                                                div(v-else-if="workflow.status == 8" class="approved")
                                                    br
                                                    | {{approvalTime(workflow.date)}}
                                                    br
                                                div(v-else class="emptySign")

                                            td(style="position: relative;")
                                                div(v-if="workflow.status == 7" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")

                                                div(v-else-if="workflow.status == 8" class="approved")
                                                    img(src="../assets/close-64.png" style="width:25px;")

                                                div(v-else class="emptySign")

                                                div(
                                                    v-if="isKTTSubstitute(workflow)"
                                                    class="custom__position-for"
                                                ) for 

                                            td
                                                p(v-if="workflow.comment || ''" class="align-left top-align comment") {{ workflow.comment }}
                                                div(v-else class="emptySign") 
                                
                                table( style="margin-top:10px;width:3cm;border: 1px solid black;" class="autoPageBreak")
                                    tbody(v-if="ipDocPengesahan") 
                                        v-btn(tile text @click="download(ipDocPengesahan)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal" height="auto") 
                                            tr
                                                td(style="padding-left:1px" ) 
                                                    v-icon(small) mdi-attachment
                                                td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                                td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                                    img(src="../assets/check.png" width="10" )
                                    tbody(v-else)
                                        tr
                                            td(style="padding-left:1px" ) 
                                                v-icon(small) mdi-attachment
                                            td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                            td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                                img(src="../assets/close.png" width="10" class="verMiddle")

                                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                                    tbody
                                        tr
                                            td(class="headerTable pl-2" colspan="11") IV. PENYELESAIAN PEKERJAAN
                                        tr
                                            td(class="pl-2" colspan="6") 
                                                b Catatan:
                                                ul
                                                    li 
                                                        i Pengawalan yang diajukan sudah sesuai dengan rencana pengawalan dan berlangsung secara aman.
                                                    li 
                                                        i Izin Pengawalan telah selesai dan tidak ada lagi pekerjaan yang dibutuhkan.
                                table(class="view-width tableCollapse tableInput")
                                    tbody
                                        tr
                                            td(class="headerTable pl-2" rowspan="4" width="5%") Pengesahan
                                            td(class="headerTable align-center" width="20%") Nama
                                            td(class="headerTable align-center" width="20%") Jabatan
                                            td(class="headerTable align-center" width="20%") Tanggal
                                            td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan 
                                        tr
                                            td
                                                div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                                    br
                                                    | {{ ip.ipFinishedWorkflow[0].name }}
                                                //- div(v-else class="emptySign")
                                                div(v-else-if="ip.ipStatus == 10 || ip.ipStatus == 11 || ip.ipStatus == 12" class="approved")
                                                    br
                                                    | {{ ip.ipPemegangIzin.name }} {{ip.ipPemegangIzin2 ? '& ' + ip.ipPemegangIzin2.name : ''}}
                                            td
                                                div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                                    br
                                                    | {{ ip.ipFinishedWorkflow[0].title }}
                                                //- div(v-else class="emptySign")
                                                div(v-else-if="ip.ipStatus == 10 || ip.ipStatus == 11 || ip.ipStatus == 12" class="approved")
                                                    br
                                                    | {{ ip.ipPemegangIzin.position }} {{ip.ipPemegangIzin2 ? '& ' + ip.ipPemegangIzin2.position : ''}}
                                            td
                                                div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                                    br
                                                    | {{approvalTime(ip.ipFinishedWorkflow[0].date)}}
                                                //- div(v-else class="emptySign")
                                                div(v-else-if="ipClosingResubmitted !== null && ipClosingSubmitted !== null"  class="approved")
                                                    br
                                                    | {{ipClosingSubmitted}} , {{ipClosingResubmitted}}
                                                div(v-else-if="ip.ipStatus == 10 || ip.ipStatus == 11 || ip.ipStatus == 12" class="approved")
                                                    br
                                                    | {{ip.ipClosingDate ? approvalTime(ip.ipClosingDate) : " "}}
                                            td
                                                div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                //- div(v-if="ip.ipStatus != '1' && ip.ipStatus != '3'" class="approved")
                                                //-     img(src="../assets/check-64.png" style="width:25px;")
                                                div(v-else-if="ip.ipStatus == 10 || ip.ipStatus == 11 || ip.ipStatus == 12"  class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                div(v-else class="emptySign")
                                            td
                                                p(class="align-left top-align comment" style="width:25px;") 
                                        tr
                                            td
                                                div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                                    br
                                                    | {{ ip.ipFinishedWorkflow[1].name }}
                                                //- div(v-else class="emptySign")
                                                div(v-else-if="ipPengesahanApproval !== null" class="approved")
                                                    br
                                                    | {{ ipPengesahanApproval.name }}
                                                div(v-else class="emptySign")
                                            td
                                                div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                                    br
                                                    | {{ ip.ipFinishedWorkflow[1].title }}
                                                //- div(v-else class="emptySign")
                                                div(v-else-if="ipPengesahanApproval !== null" class="approved")
                                                    br
                                                    | {{ ipPengesahanApproval.title }}
                                                div(v-else class="emptySign")
                                            td
                                                div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                                    br
                                                    | {{approvalTime(ip.ipFinishedWorkflow[1].date)}}
                                                //- div(v-else class="emptySign")
                                                div(v-else-if="ipPengesahanApproval !== null" class="approved")
                                                    br
                                                    | {{ipPengesahanApproval.date ? approvalTime(ipPengesahanApproval.date) : ''}}
                                                div(v-else class="emptySign")
                                            td
                                                div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                //- div(v-else class="emptySign")
                                                div(v-if="ipPengesahanApproval ? ipPengesahanApproval.status == 7 : false" class="approved")
                                                    img(src="../assets/check-64.png" style="width:25px;")
                                                div(v-else class="emptySign")
                                            td
                                                p(v-if="ipPengesahanApproval !== null" class="align-left top-align comment") {{ ipPengesahanApproval.comment }}
                                                div(v-else class="emptySign" style="width:25px;")
                LampiranPlain(v-for="attachment in ip.ipLinkedAttachment" dialogType="approval" :ip="attachment" :parentIpNo="ip.ipNo" :pengajuUser="ip.ipWorkflow[0]" class="autoPageBreak" :key="attachment._id" :fullApproved="ip.ipStatus")
</template>

<script>
import axios from 'axios';
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import { mapState } from 'vuex';
import printJS from 'print-js';
import LampiranPlain from './LampiranPlain.vue';
import { handleGlobalErrorApproval } from '../helper/handleGlobalError.js';
export default {
  name: 'PengawalanView',
  components: {
      LampiranPlain
  },
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object
  },
  data: () => ({
    formName: config.FormName,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    approval: null,
    share: false,
    print: false,
    snackbar: false,
    snackbarMessage: ''
  }),
  computed: {
    ...mapState(['API_URL', "networks", "sharing", "shortenUrl"]),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
    ipPengesahanApproval() {
      return this.ip?.ipPengesahan?.ipWorkflow[0] || null;
    },
    ipClosingResubmitted() {
      return !this.ip?.ipPengesahan?.ipClosingResubmitted ? '' : this.approvalTime(this.ip.ipPengesahan.ipClosingResubmitted);
    },
    ipClosingSubmitted() {
      return !this.ip?.ipPengesahan?.ipClosingSubmitted ? '' : this.approvalTime(this.ip.ipPengesahan.ipClosingSubmitted);
    },
    ipDocPengesahan() {
      return this.ip?.ipPengesahan?.ipAttachmentFiles?.docPendukung ?? this.ip?.ipPengesahan?.ipAttachmentFiles?.docPelaporan ?? this.ip?.ipAttachmentFiles?.docPelaporan ?? null;
    },
    setJenisPengawalan() {
        let valueJenisPengawalan = this.ip?.ipJenisPengawalan;
        if (!valueJenisPengawalan) return valueJenisPengawalan;

        return valueJenisPengawalan
            .replace(new RegExp('unit baru masuk', 'gi'), 'Unit Baru Masuk (UBM)')
            .replace(new RegExp('pindah lokasi kerja', 'gi'), 'Pindah Lokasi Kerja (PLK)');
    }
  },
  methods: {
    jabatanDetail: helper.jabatanDetail,
    download(file) {
        this.$downloadFile(file);
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share}).then(() => {
            this.share = true;
        });
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css", '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    formatDate: helper.formatDateOnly,
    getApproveStatus(wf){
        let status = 0;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik && !this.isCurrentApprover()){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        return helper.isApprover(
            this.$store.getters.isAuthenticated,
            this.ip,
            this.approvalUser
        );
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    },
    getNameApproverKTT(item) {
        return helper.getKTTApproverName(item)
    },
    isKTTSubstitute(item) {
        return helper.isKTTSubstitute(item)
    },
    getTitleApprover(item) {
        if ( item.matrix == 'KTT' ) {
            return 'Kepala Teknik Tambang'
        } else {
            return item.title
        }
    }
  },
  watch: {
    approvalDialog2 (val) {
        if (!val) return
        if(this.ip.ipStatus == 10){
            const NewFormData = {
                formId : this.ip._id,
                status : parseInt(this.approval),
                comment : this.comment,
                approvalUser : this.approvalUser
            }
            const config = {
                method: "post",
                url: `${this.API_URL}/v1/pengesahan/approval`,
                headers: {"Authorization": `Bearer ${this.$store.state.token}`},
                data: NewFormData
            };
            axios(config).then(res => {
                if (res.status == 200) {
                    setTimeout(() => {
                        this.dialog2 = false;
                        this.dialog = false;
                        location.reload();
                    },
                    1000);
                }
            }).catch(error => {
                handleGlobalErrorApproval(error, {
                    setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                    showSnackbar: (show) => { this.snackbar = show; },
                    closeModals: () => { 
                        this.approvalDialog = false; 
                        this.approvalDialog2 = false; 
                    },
                    disableLoader: () => { 
                        this.$store.state.loader = false;
                    },
                });
            });
        }else{
            let formData = new FormData();
            formData.append('_id', this.ip._id);
            formData.append('status', parseInt(this.approval));
            formData.append('comment', this.comment);
            formData.append('approvalUser', JSON.stringify(this.approvalUser));
            formData.append('formCode', this.ip.ipForm);
            const sourceApproval = this.$route.query.sourceApproval || "";
            formData.append('sourceApproval', sourceApproval);
            const config = {
                method: "put",
                url: `${this.API_URL}/v1/requests/approval`,
                headers: {"Authorization": `Bearer ${this.$store.state.token}`},
                data: formData
            };
            axios(config).then(res => {
                if (res.status == 200) {
                    setTimeout(() => {
                        this.dialog2 = false;
                        this.dialog = false;
                        location.reload();
                    },
                    1000);
                }
            }).catch(error => {
                handleGlobalErrorApproval(error, {
                    setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                    showSnackbar: (show) => { this.snackbar = show; },
                    closeModals: () => { 
                        this.approvalDialog = false; 
                        this.approvalDialog2 = false; 
                    },
                    disableLoader: () => { 
                        this.$store.state.loader = false;
                    },
                });
            });
        }     
    }
  }
};
</script>
<style scoped>
.ck-editor__editable {
    min-height: 200px !important;
    max-height: 600px !important;
}
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.tableCollapse td{
    border: 1px solid black;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    text-align: center;
    padding: 5px;
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.65;
}
.fontWatermarkUp {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  right: 200px;
  color: rgb(224,224,224);
}
.fontWatermarkDown {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  top: 450px;
  right: 100px;
  color: rgb(224,224,224);
}

.custom__position-for{
  font-size: 8px; 
  font-style: italic; 
  position: absolute; 
  bottom: 0; 
  left: 0;
}
</style>